import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button } from '../../../UI'
import DropDown from '../../../Input/DropDown'
import ErrorMessageWithExclamation from '../../../UI/ErrorMessageWithExclamation'

import { CryptoPaymentScheme } from '../../../../routing/utils/validators'

import { cryptoPaymentCurrencies, cryptoPaymentNetworks } from '../../../../constants'

const TopUpPaymentModalCryptocurrencies = ({ onPayment, isLoading, error, resetError }) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      currency: '',
      network: '',
    },
    resolver: yupResolver(CryptoPaymentScheme),
  })

  const handleFormSubmit = (data) => {
    console.log(data)

    if (onPayment) {
      onPayment(data)
    }
  }

  useEffect(() => {
    return () => {
      if (resetError) {
        resetError()
      }
    }
  }, [])

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="w-full flex flex-col items-start">
      {!!error && <ErrorMessageWithExclamation text={error} className="mb-[16px]" />}

      <div className="w-full flex flex-col items-start">
        <span className="inline-block mb-[10px] text-sm font-normal text-[#F79009]">
          Select Cryptocurrencies
        </span>

        <Controller
          control={control}
          name="currency"
          render={({ field: { value, onChange } }) => {
            return (
              <DropDown
                className="!h-[44px]"
                placeholder="Select Cryptocurrencies"
                value={value}
                setValue={onChange}
                menuItems={cryptoPaymentCurrencies}
                renderItem={(currency) => {
                  return (
                    <div className="flex items-center">
                      <img src={currency.icon} alt={currency.value} className="w-[24px] h-[24px]" />

                      <span className="text-base text-primary-100 font-normal ml-[8px]">
                        {currency.label}
                      </span>
                    </div>
                  )
                }}
              />
            )
          }}
        />

        {errors.currency && <ErrorMessageWithExclamation text={errors.currency.message} />}
      </div>

      <div className="w-full flex flex-col items-start mt-[10px]">
        <span className="inline-block mb-[10px] text-sm font-normal text-[#F79009]">
          Select Network
        </span>

        <Controller
          control={control}
          name="network"
          render={({ field: { value, onChange } }) => {
            return (
              <DropDown
                className="!h-[44px]"
                placeholder="Select Network"
                value={value}
                setValue={onChange}
                menuItems={cryptoPaymentNetworks}
                shouldRenderItemSelected={false}
                renderItem={(network) => {
                  return (
                    <div className="flex flex-col items-start">
                      <span className="text-xl text-primary-100 font-bold">{network.label}</span>

                      <span className="text-base font-normal text-primary-100">
                        {network.description}
                      </span>
                    </div>
                  )
                }}
              />
            )
          }}
        />

        {errors.network && <ErrorMessageWithExclamation text={errors.network.message} />}
      </div>

      <Button type="submit" isLoading={isLoading} className="mt-[24px] w-full text-base font-bold">
        Confirm Payment
      </Button>

      <p className="mt-[10px] text-sm text-[#F79009]">
        By clicking on “confirm payment“, you agree to our{' '}
        <a href="/" target="_blank" className="font-bold underline hover:text-[#F79009]">
          payment and refund policy
        </a>
        .
      </p>
    </form>
  )
}

export default TopUpPaymentModalCryptocurrencies
